export default {
      id: "color_cart-usage",
      viewBox: "0 0 82 73",
      url: __webpack_public_path__ + "sprite.svg#color_cart",
      toString: function () {
        return this.url;
      }
    }